import axios from "axios";
import { Urls } from "../../slices/urls";
import { ServiceUrls, RegisterServiceUrls } from "../../../store/serviceUrl";

export const fetchUserRepo = (sessionKey) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.USER_DETAIL_API,
    headers: { "sid": sessionKey || null },
  });
};

export const getCreateUserRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_USER_EDIT_PROFILE_API,
    params: params,
  });
};

export const postCreateUserRepo = (data, params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_USER_EDIT_PROFILE_API,
    params: params,
    data: data,
  });
};
export const postValidateFieldsRepo = (data) => {
  return axios({
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    url: window?.origin + "/ajax/no-cache/user/validate-fields",
    data: data,
  });
};

export const logoutUserRepo = (data) => {
  return axios({
    method: "POST",
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    url: Urls.LOGOUT_API,
    data: data,
    });
};

export const userPushToLSQRepo = (data) => {
  return axios({
    method: "POST",
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    url: Urls.USER_PUSH_TO_LSQ,
    data: data,
    });
};
